// globalStyle.js
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  /* ====== Webfonts ======
     Dica: se preferir performance máxima, use <link> no index.html em vez de @import. */
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');

  /* ==================== TOKENS ==================== */
  :root {
    /* -------- Colors (desktop + mobile) -------- */
    --color-060607: #060607;
    --color-0a1323: #0a1323;
    --color-f9fbff: #f9fbff;
    --color-0b162c: #0b162c;
    --color-181818: #181818;
    --color-000000: #000000;
    --color-ffffff: #ffffff;
    --color-d72082: #d72082;
    --color-6A2AFF: #6A2AFF;
    --color-9747FF: #9747FF;
    --color-3F145E:#3F145E;
    --color-A62AFF: #A62AFF;
    --color-8A69BE: #8A69BE;
    --color-a786f6: #a786f6;
    --color-8b8b8b: #8b8b8b;
    --color-001949: #001949;
    --color-002C81: #002C81;
    --color-002f88: #002f88;
    --color-003fb9: #003fb9;
    --color-0057FF: #0057FF;
    --color-0053F1: #0053F1;
    --color-2a73ff: #2a73ff;
    --color-4C89FF: #4C89FF;
    --color-6A9DFF: #6A9DFF;
    --color-A6C4FF: #A6C4FF;
    --color-e2ecff: #e2ecff;
    --color-border-dark: #353535;
    --color-ff7022:#FF7022;
    --color-1D1D1D: #1D1D1D;
    --color-1B1B1F:#1B1B1F;
    --color-666666:#666666;
    --color-9D4DFF:#9D4DFF;
    --color-ff0099: #ff0099;
    --color-3c3c3b:#3c3c3b;
    --color-7929d2:#7929d2;
    --color-02142a:#02142a;
    --color-11414b:#11414b;
    --color-63c45c:#63c45c;
    

    /* -------- font -------- */
    
    --fs-12: 12px;
    --fs-14: 14px;
    --fs-16: 16px;
    --fs-20: 20px;
    --fs-24: 24px;
    --fs-32: 32px;
    --fs-40: 40px;

    --fw-400: 400;
    --fw-600: 600;
    --fw-700: 700;

    --lh-12: 1.4;
    --lh-14: 1.5;
    --lh-16: 1.5;
    --lh-20: 1.4;
    --lh-24: 1.3;
    --lh-32: 1.25;
    --lh-40: 1.2;

    /* -------- Typography -------- */

    --font-primary: "Open Sans", system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    --font-secondary: Arial, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, sans-serif;

    /* -------- Spacing scale -------- */
    --space-0: 0;
    --space-4: 4px;
    --space-8: 8px;
    --space-10: 10px;
    --space-12: 12px;
    --space-13: 13px;
    --space-16: 16px;
    --space-18: 18px;
    --space-20: 20px;
    --space-24: 24px;
    --space-32: 32px;
    --space-40: 40px;
    --space-48: 48px;
    --space-55: 55px;
    --space-56: 56px;
    --space-64: 64px;
    --space-80: 80px;
    --space-86: 86px;
    --space-96: 96px;
    --space-120: 120px;
    --space-124: 124px;
    --space-128: 128px;
    --space-130: 130px;
    --space-140: 140px;
    --space-146: 146px;

     /* -------- Radius & Borders -------- */

    --radius-sm: 8px;
    --radius-md: 16px;
    --radius-lg: 24px;
    --radius-pill: 64px;
    --radius-xxl: 68px;

    --border-width: 1px;

  }

  /* ==================== RESET & BASE ==================== */
  *, *::before, *::after { 
      box-sizing: border-box;
      margin: 0; 
      padding: 0; 
    }
  img, picture, video, canvas, svg {  
     display: block;
     max-width: 100%;
   }
  input, button, textarea, select { 
    font: inherit;
     color: inherit;
   }
  button { 
    background: none;
     border: none;
     cursor: pointer;
   }
  ul, ol { 
    list-style: none;
   }
  a {
     text-decoration: none;
     color: inherit;
   }
  html, body, #root { 
    height: 100%;
   }

  /* ==================== THEME DEFAULTS ==================== */
  body {
    font-family: var(--font-primary);
    background-color: var(--color-000000);
    color: var(--color-f9fbff);
    overflow-x: hidden;
  }

  .App {
    text-align: center;
  }

`;
